var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "monetizationSection",
    staticClass: "flexs column",
    style: {
      background: _vm.backColor,
      padding: _vm.paddingAll
    }
  }, [_c('span', {
    staticClass: "margin-b-100 title-element",
    class: _vm.titleAnimationClasses,
    style: {
      fontSize: _vm.fontSize + 'px',
      color: _vm.color,
      fontWeight: _vm.weight
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };